import Cookies from 'js-cookie';

export default function isAnalyticsEnabled() {
    return Cookies.get('cc_cookie') && JSON.parse(Cookies.get('cc_cookie')).categories.includes('analytics')
}